import React from 'react'

const Footer = () => {
    return(
        <footer>
            <div className="container">
                <h5>
                    © Copyright {new Date().getFullYear()} Centre Médical Bonnevoie
                </h5>
                <h5>
                    developed by <a href="https://www.intimesit.com" title="intimesit.com">InTimesIT</a>
                </h5>
            </div>
        </footer>

    )
}

export default Footer